'use strict'

var parse = require('./util/dictionary.js')

module.exports = add

// Add a dictionary file.
function add(buf) {
  var self = this
  var index = -1
  var rule
  var source
  var character
  var offset

  parse(buf, self, self.data)

  // Regenerate compound expressions.
  while (++index < self.compoundRules.length) {
    rule = self.compoundRules[index]
    source = ''
    offset = -1

    while (++offset < rule.length) {
      character = rule.charAt(offset)
      source += self.compoundRuleCodes[character].length
        ? '(?:' + self.compoundRuleCodes[character].join('|') + ')'
        : character
    }

    self.compoundRules[index] = new RegExp(source, 'i')
  }

  return self
}
